type Rgb = readonly [number, number, number]

const HEX3 = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/i
const HEX6 = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i
const RGB = /^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/i

const parseColor = (css: string | null | undefined): Rgb | null => {
  if (!css) return null
  const s = css.trim()
  const h3 = s.match(HEX3)
  if (h3) {
    return [
      parseInt(h3[1] + h3[1], 16),
      parseInt(h3[2] + h3[2], 16),
      parseInt(h3[3] + h3[3], 16),
    ]
  }
  const h6 = s.match(HEX6)
  if (h6) {
    return [parseInt(h6[1], 16), parseInt(h6[2], 16), parseInt(h6[3], 16)]
  }
  const rgb = s.match(RGB)
  if (rgb) return [Number(rgb[1]), Number(rgb[2]), Number(rgb[3])]
  return null
}

const relativeLuminance = ([r, g, b]: Rgb): number => {
  const lin = (v: number): number => {
    const c = v / 255
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4
  }
  return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b)
}

const contrastRatio = (a: Rgb, b: Rgb): number => {
  const la = relativeLuminance(a)
  const lb = relativeLuminance(b)
  const hi = Math.max(la, lb)
  const lo = Math.min(la, lb)
  return (hi + 0.05) / (lo + 0.05)
}

const WHITE = '#ffffff'
const DARK = '#2b2b2b'
const MIN_PREVIEW_CONTRAST = 3

export const pickLegibleBackdrop = (
  textColor: string | null | undefined,
): string => {
  const text = parseColor(textColor)
  if (!text) return WHITE
  const white = parseColor(WHITE) as Rgb
  return contrastRatio(text, white) >= MIN_PREVIEW_CONTRAST ? WHITE : DARK
}
